import { Card, Typography, Loader, LabelValue } from '@design-system/index';
import '../../DetailsPage.scss';
import './DetailsPlanning.scss';
import { Grid } from '@design-system/components/Grid/Grid';
import { useDetailsPlanningVM } from './useDetailsPlanningVM';
import { APARTMENT_TYPE } from '@utils/enumTranslation';
import PlanningCalendar from './PlanningCalendar/PlanningCalendar';

export default function DetailsPlanning() {
    const { isLoading, isError, apartment } = useDetailsPlanningVM();

    if (isLoading) {
        return <Loader className="full-container-loader" />;
    }

    if (isError) {
        return (
            <Typography intrinsic="p" color="secondary">
                Une erreur est survenue lors de la récupération des informations de la fiche logement
            </Typography>
        );
    }

    if (!apartment) {
        return <></>;
    }

    return (
        <div className="details-apartment-container">
            <div className="details-apartment-container-body">
                <Card headerType="very-light" headerTitle={apartment.fullname}>
                    <Grid columns={3}>
                        <LabelValue label="Référence" value={apartment.reference} />
                        <LabelValue label="Intitulé du logement" value={apartment.label} />
                        <LabelValue label="Type de logement" value={APARTMENT_TYPE[apartment.type]} />
                    </Grid>
                </Card>

                <Card headerType="very-light" headerTitle={'Planning des réservations'}>
                    <PlanningCalendar apartmentId={apartment.id} />
                </Card>
            </div>
        </div>
    );
}
